(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-lens-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__contactLensCollectionSortReady) return;
    window.__contactLensCollectionSortReady = true;

    const desktopFilters = window.matchMedia('(min-width: 990px)');
    const syncFilterPanels = () => {
      document.querySelectorAll('[data-contact-lens-collection] [data-cl-filter-shell]').forEach((panel) => {
        panel.open = desktopFilters.matches;
      });
    };

    syncFilterPanels();
    desktopFilters.addEventListener('change', syncFilterPanels);
    document.addEventListener('shopify:section:load', syncFilterPanels);

    let priceFilterTimer = null;
    let collectionRequestController = null;

    const currentTagHandles = (root) => {
      const element = root.querySelector('[data-cl-current-tags]');
      if (!element) return [];
      try {
        const tags = JSON.parse(element.textContent || '[]');
        return Array.isArray(tags) ? tags : [];
      } catch {
        return [];
      }
    };

    const mergeCurrentSearch = (url) => {
      const current = new URL(window.location.href);
      current.searchParams.forEach((value, key) => {
        if (key !== 'page' && key !== 'section_id') url.searchParams.append(key, value);
      });
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      return url;
    };

    const tagFilterUrl = (root, tag, groupTags = [], removeOnly = false) => {
      const activeTags = currentTagHandles(root);
      const isActive = activeTags.includes(tag);
      const excludedTags = removeOnly ? [tag] : groupTags;
      const nextTags = activeTags.filter((activeTag) => !excludedTags.includes(activeTag));
      if (!removeOnly && !isActive) nextTags.push(tag);
      const path = `${root.dataset.collectionUrl}${nextTags.length ? `/${nextTags.join('+')}` : ''}`;
      return mergeCurrentSearch(new URL(path, window.location.origin));
    };

    const formFilterUrl = (form) => {
      const url = new URL(form.action, window.location.origin);
      url.search = '';
      const data = new FormData(form);
      data.forEach((value, key) => {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      });
      url.searchParams.delete('page');
      return url;
    };

    const replaceCollection = async (currentRoot, nextRoot) => {
      const replace = () => currentRoot.replaceWith(nextRoot);
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        await document.startViewTransition(replace).updateCallbackDone;
      } else {
        replace();
      }
    };

    const loadCollection = async (targetUrl, updateHistory = true) => {
      const currentRoot = document.querySelector('[data-contact-lens-collection]');
      if (!currentRoot) {
        window.location.assign(targetUrl.toString());
        return;
      }

      if (collectionRequestController) collectionRequestController.abort();
      collectionRequestController = new AbortController();
      const filterShell = currentRoot.querySelector('[data-cl-filter-shell]');
      const keepMobileFiltersOpen = Boolean(filterShell && filterShell.open && !desktopFilters.matches);
      const requestUrl = new URL(targetUrl.toString());
      requestUrl.searchParams.set('section_id', currentRoot.dataset.sectionId);
      currentRoot.classList.add('is-loading');
      currentRoot.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(requestUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: collectionRequestController.signal
        });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = parsed.querySelector('[data-contact-lens-collection]');
        if (!nextRoot) throw new Error('Collection section missing');

        nextRoot.dataset.clLoaded = 'ajax';
        if (updateHistory) window.history.pushState({}, '', targetUrl.toString());
        await replaceCollection(currentRoot, nextRoot);
        syncFilterPanels();
        if (keepMobileFiltersOpen) {
          const nextFilterShell = nextRoot.querySelector('[data-cl-filter-shell]');
          if (nextFilterShell) nextFilterShell.open = true;
        }
        initializeBanners(nextRoot);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(targetUrl.toString());
      }
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.cl-collection__filter-form');
      if (!form) return;
      event.preventDefault();
      loadCollection(formFilterUrl(form));
    });

    document.addEventListener('input', (event) => {
      const priceInput = event.target.closest('.cl-collection__filter-form .cl-filter__price input');
      if (!priceInput) return;
      if (priceFilterTimer) window.clearTimeout(priceFilterTimer);
      priceFilterTimer = window.setTimeout(() => priceInput.form.requestSubmit(), 500);
    });

    document.addEventListener('change', (event) => {
      const filterControl = event.target.closest('.cl-collection__filter-form input:not([type="hidden"])');
      if (filterControl) {
        if (filterControl.closest('.cl-filter__price')) return;
        filterControl.form.requestSubmit();
        return;
      }

      const selector = event.target.closest('[data-cl-sort]');
      if (!selector) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', selector.value);
      url.searchParams.delete('page');
      loadCollection(url);
    });

    document.addEventListener('click', (event) => {
      if ((event.button && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const root = event.target.closest('[data-contact-lens-collection]');
      if (!root) return;

      const tagOption = event.target.closest('[data-cl-tag]');
      if (tagOption) {
        event.preventDefault();
        const groupTags = Array.from(tagOption.closest('[data-cl-tag-filter]').querySelectorAll('[data-cl-tag]'))
          .map((option) => option.dataset.clTag);
        loadCollection(tagFilterUrl(root, tagOption.dataset.clTag, groupTags));
        return;
      }

      const activeTag = event.target.closest('[data-cl-active-tag]');
      if (activeTag) {
        event.preventDefault();
        loadCollection(tagFilterUrl(root, activeTag.dataset.clActiveTag, [], true));
        return;
      }

      const clearAll = event.target.closest('[data-cl-clear-all]');
      if (clearAll) {
        event.preventDefault();
        loadCollection(new URL(clearAll.href, window.location.origin));
        return;
      }

      const ajaxLink = event.target.closest('[data-cl-ajax-link], .pagination-wrapper a, .pagination a');
      if (ajaxLink && root.contains(ajaxLink)) {
        event.preventDefault();
        loadCollection(new URL(ajaxLink.href, window.location.origin));
      }
    });

    window.addEventListener('popstate', () => loadCollection(new URL(window.location.href), false));

    const initializeBanner = (banner) => {
      if (banner.dataset.clBannerInitialized === 'true') return;
      banner.dataset.clBannerInitialized = 'true';

      const track = banner.querySelector('[data-cl-banner-track]');
      const slides = Array.from(banner.querySelectorAll('[data-cl-banner-slide]'));
      const dots = Array.from(banner.querySelectorAll('[data-cl-banner-dot]'));
      const previous = banner.querySelector('[data-cl-banner-previous]');
      const next = banner.querySelector('[data-cl-banner-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const speed = Math.max(3000, Number(banner.dataset.speed || 6000));
      let current = 0;
      let timer = null;
      let scrollFrame = null;

      if (!track || slides.length < 2) return;

      const slideOffset = (slide) => slide.offsetLeft - slides[0].offsetLeft;
      const updateDots = () => {
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
      };
      const goTo = (index, behavior = 'smooth') => {
        current = (index + slides.length) % slides.length;
        track.scrollTo({ left: slideOffset(slides[current]), behavior });
        updateDots();
      };
      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (banner.dataset.autoplay !== 'true' || reducedMotion.matches) return;
        timer = window.setInterval(() => goTo(current + 1), speed);
      };

      previous?.addEventListener('click', () => { goTo(current - 1); start(); });
      next?.addEventListener('click', () => { goTo(current + 1); start(); });
      dots.forEach((dot, index) => dot.addEventListener('click', () => { goTo(index); start(); }));
      track.addEventListener('scroll', () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const nearest = slides.reduce((best, slide, index) => (
            Math.abs(track.scrollLeft - slideOffset(slide)) < Math.abs(track.scrollLeft - slideOffset(slides[best])) ? index : best
          ), 0);
          if (nearest !== current) {
            current = nearest;
            updateDots();
          }
        });
      }, { passive: true });
      banner.addEventListener('mouseenter', stop);
      banner.addEventListener('mouseleave', start);
      banner.addEventListener('focusin', stop);
      banner.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      updateDots();
      start();
    };

    const initializeBanners = (scope = document) => {
      scope.querySelectorAll('[data-cl-banner]').forEach(initializeBanner);
    };

    initializeBanners();
    document.addEventListener('shopify:section:load', (event) => initializeBanners(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-lens-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.clInitialized === 'true') return;
      root.dataset.clInitialized = 'true';
      root.classList.add('is-cl-enhanced');

      const form = root.querySelector('[data-cl-form]');
      const submit = root.querySelector('[data-cl-submit]');
      const submitLabel = root.querySelector('[data-cl-submit-label]');
      const totalPrice = root.querySelector('[data-cl-total-price]');
      const formMessage = root.querySelector('[data-cl-form-message]');
      const postAdd = root.querySelector('[data-cl-post-add]');
      const sameToggle = root.querySelector('[data-cl-same-prescription]');
      const eyesContainer = root.querySelector('[data-cl-eyes]');
      const eyeElements = Array.from(root.querySelectorAll('[data-cl-eye]'));
      const panels = Array.from(root.querySelectorAll('[data-cl-panel]'));
      const modeButtons = Array.from(root.querySelectorAll('[data-cl-mode]'));
      const planoQuantity = root.querySelector('[data-cl-plano-quantity]');
      const resolutionCache = new Map();
      const matrixElement = root.querySelector('[data-cl-prescription-matrix]');
      const matrixKeys = ['sphere', 'cylinder', 'axis'];
      let prescriptionMatrix = [];
      let requestSequence = 0;
      let mode = root.dataset.defaultMode;
      let submitting = false;
      const colourSwatches = Array.from(root.querySelectorAll('[data-cl-colour-swatch]'));
      const currentColourSwatch = colourSwatches.find((swatch) => swatch.hasAttribute('data-cl-current-colour'));
      const colourSelectionKey = 'contact-lens-colour-selection';

      const setSelectedColour = (selectedSwatch) => {
        colourSwatches.forEach((swatch) => {
          const selected = swatch === selectedSwatch;
          swatch.classList.toggle('is-current', selected);
          if (selected) swatch.setAttribute('aria-current', 'true');
          else swatch.removeAttribute('aria-current');
        });
      };

      if (currentColourSwatch) {
        try {
          if (window.sessionStorage.getItem(colourSelectionKey) === window.location.pathname) {
            setSelectedColour(currentColourSwatch);
          }
        } catch {}
      }

      colourSwatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          if (swatch.classList.contains('is-unavailable')) {
            event.preventDefault();
            return;
          }
          const target = new URL(swatch.href, window.location.origin);
          try {
            window.sessionStorage.setItem(colourSelectionKey, target.pathname);
          } catch {}
          if (target.pathname === window.location.pathname && !target.searchParams.has('variant')) {
            event.preventDefault();
            setSelectedColour(swatch);
          }
        });
      });

      if (matrixElement) {
        try {
          prescriptionMatrix = JSON.parse(matrixElement.textContent || '[]');
        } catch (error) {
          prescriptionMatrix = [];
        }
      }

      const usesPrescriptionMatrix = prescriptionMatrix.length > 0;

      const formatMoney = (cents) => {
        const value = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-AE', {
            style: 'currency',
            currency: root.dataset.currency || 'AED'
          }).format(value);
        } catch (error) {
          return `${root.dataset.currency || 'AED'} ${value.toFixed(2)}`;
        }
      };

      const setFormMessage = (message, type) => {
        formMessage.textContent = message || '';
        formMessage.classList.toggle('is-error', type === 'error');
        formMessage.classList.toggle('is-success', type === 'success');
      };

      const setEyeStatus = (eye, message, type) => {
        const status = eye.element.querySelector('[data-cl-eye-status]');
        status.textContent = message || '';
        status.classList.toggle('is-error', type === 'error');
        status.classList.toggle('is-success', type === 'success');
      };

      const updateDisplayedUnitPrice = (price, comparePrice) => {
      const priceElement = root.querySelector('[data-cl-unit-price]');
      const compareElement = root.querySelector('[data-cl-compare-price]');
      const savingElement = root.querySelector('[data-cl-saving]');
      const discountElement = root.querySelector('[data-cl-discount]');
        const numericPrice = Number(price || 0);
        const requestedComparePrice = Number(comparePrice || 0);
        const defaultComparePrice = Number(root.dataset.defaultComparePrice || 0);
        const numericComparePrice = requestedComparePrice > numericPrice
          ? requestedComparePrice
          : defaultComparePrice > numericPrice
            ? defaultComparePrice
            : 0;
        const onSale = numericComparePrice > numericPrice && numericPrice > 0;
        if (priceElement && numericPrice > 0) priceElement.textContent = formatMoney(numericPrice);
        if (compareElement) {
          if (onSale) {
            compareElement.textContent = formatMoney(numericComparePrice);
            compareElement.classList.remove('is-hidden');
          } else {
            compareElement.textContent = '';
            compareElement.classList.add('is-hidden');
          }
        }
        if (savingElement) {
          savingElement.textContent = onSale
            ? (root.dataset.savingTemplate || 'Save __AMOUNT__').replace('__AMOUNT__', formatMoney(numericComparePrice - numericPrice))
            : '';
          savingElement.classList.toggle('is-hidden', !onSale);
        }
        if (discountElement) {
          const percent = onSale ? Math.round(((numericComparePrice - numericPrice) * 100) / numericComparePrice) : 0;
          discountElement.textContent = onSale
            ? (root.dataset.discountTemplate || '__PERCENT__% off').replace('__PERCENT__', String(percent))
            : '';
          discountElement.classList.toggle('is-hidden', !onSale);
        }
      };

      const eyes = eyeElements.map((element) => ({
        element,
        key: element.dataset.clEye,
        selects: Array.from(element.querySelectorAll('[data-cl-option]')),
        quantity: element.querySelector('[data-cl-eye-quantity]'),
        variant: null,
        token: 0
      }));

      const quantitySteppers = Array.from(root.querySelectorAll('[data-cl-quantity-stepper]')).map((stepper) => ({
        stepper,
        select: stepper.parentElement.querySelector('.cl-quantity-select'),
        value: stepper.querySelector('[data-cl-quantity-value]'),
        decrease: stepper.querySelector('[data-cl-quantity-action="decrease"]'),
        increase: stepper.querySelector('[data-cl-quantity-action="increase"]')
      })).filter((control) => control.select);

      const syncQuantityStepper = (control) => {
        const option = control.select.options[control.select.selectedIndex];
        control.value.textContent = option ? option.textContent.trim() : control.select.value;
        control.decrease.disabled = control.select.disabled || control.select.selectedIndex <= 0;
        control.increase.disabled = control.select.disabled || control.select.selectedIndex >= control.select.options.length - 1;
      };

      const syncQuantitySteppers = () => quantitySteppers.forEach(syncQuantityStepper);

      quantitySteppers.forEach((control) => {
        control.stepper.querySelectorAll('[data-cl-quantity-action]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const direction = button.dataset.clQuantityAction === 'increase' ? 1 : -1;
            const currentIndex = Math.max(0, control.select.selectedIndex);
            const nextIndex = Math.max(0, Math.min(control.select.options.length - 1, currentIndex + direction));
            if (nextIndex === currentIndex) {
              syncQuantityStepper(control);
              return;
            }
            control.select.selectedIndex = nextIndex;
            syncQuantityStepper(control);
            control.select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        control.select.addEventListener('change', () => syncQuantityStepper(control));
        syncQuantityStepper(control);
      });

      const defaultVariant = {
        id: root.dataset.defaultVariantId,
        available: root.dataset.defaultAvailable === 'true',
        price: Number(root.dataset.defaultPrice || 0),
        comparePrice: Number(root.dataset.defaultComparePrice || 0)
      };

      const populateMatrixOptions = (eye) => {
        eye.selects.forEach((select, index) => {
          const previousValue = select.value;
          const matchingRows = prescriptionMatrix.filter((row) => eye.selects
            .slice(0, index)
            .every((previousSelect, previousIndex) => !previousSelect.value || row[matrixKeys[previousIndex]] === previousSelect.value));
          const values = Array.from(new Set(matchingRows.map((row) => row[matrixKeys[index]])));
          select.replaceChildren();
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = select.dataset.placeholder || root.dataset.selectLabel;
          select.appendChild(placeholder);
          values.forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.dataset.label = value;
            option.textContent = value;
            select.appendChild(option);
          });
          select.value = values.includes(previousValue) ? previousValue : '';
        });
      };

      if (usesPrescriptionMatrix) eyes.forEach(populateMatrixOptions);

      if (!usesPrescriptionMatrix && eyes.every((eye) => eye.selects.length === 0) && defaultVariant.id) {
        eyes.forEach((eye) => {
          eye.variant = defaultVariant;
          setEyeStatus(eye, defaultVariant.available ? root.dataset.availableLabel : root.dataset.unavailableLabel, defaultVariant.available ? 'success' : 'error');
        });
      }

      const selectedOptionIds = (eye) => eye.selects.map((select) => select.value).filter(Boolean);

      const prescriptionSummary = (eye) => eye.selects
        .map((select) => {
          const option = select.options[select.selectedIndex];
          return option && option.value ? `${select.dataset.optionName}: ${option.dataset.label || option.textContent.trim()}` : '';
        })
        .filter(Boolean)
        .join(' · ');

      const resolveVariant = async (eye) => {
        if (eye.selects.length === 0) return eye.variant;
        if (usesPrescriptionMatrix) {
          populateMatrixOptions(eye);
          const values = eye.selects.map((select) => select.value);
          if (values.some((value) => !value)) {
            eye.variant = null;
            setEyeStatus(eye, root.dataset.selectLabel, '');
            updateState();
            return null;
          }

          const validCombination = prescriptionMatrix.some((row) => matrixKeys.every((key, index) => row[key] === values[index]));
          eye.variant = validCombination && defaultVariant.available ? defaultVariant : null;
          if (eye.variant) {
            setEyeStatus(eye, `${prescriptionSummary(eye)} · ${formatMoney(defaultVariant.price)}`, 'success');
            updateDisplayedUnitPrice(defaultVariant.price, defaultVariant.comparePrice);
          } else {
            setEyeStatus(eye, root.dataset.unavailableLabel, 'error');
          }
          updateState();
          return eye.variant;
        }

        const ids = selectedOptionIds(eye);
        if (ids.length !== eye.selects.length) {
          eye.variant = null;
          setEyeStatus(eye, root.dataset.selectLabel, '');
          updateState();
          return null;
        }

        const key = ids.join(',');
        const currentToken = ++requestSequence;
        eye.token = currentToken;
        setEyeStatus(eye, root.dataset.checkingLabel, '');
        updateState();

        try {
          let resolved = resolutionCache.get(key);
          if (!resolved) {
            const url = new URL(root.dataset.productUrl, window.location.origin);
            url.searchParams.set('section_id', root.dataset.sectionId);
            url.searchParams.set('option_values', key);
            const response = await fetch(url.toString(), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) throw new Error(`Variant lookup failed: ${response.status}`);
            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const marker = documentFragment.querySelector('[data-cl-variant-resolution]');
            if (!marker || !marker.dataset.variantId) {
              resolved = { id: '', available: false, price: 0, comparePrice: 0 };
            } else {
              resolved = {
                id: marker.dataset.variantId,
                available: marker.dataset.available === 'true',
                price: Number(marker.dataset.price || 0),
                comparePrice: Number(marker.dataset.comparePrice || 0)
              };
            }
            resolutionCache.set(key, resolved);
          }

          if (eye.token !== currentToken) return null;
          eye.variant = resolved.id ? resolved : null;
          if (!resolved.id || !resolved.available) {
            setEyeStatus(eye, root.dataset.unavailableLabel, 'error');
          } else {
            setEyeStatus(eye, `${prescriptionSummary(eye)} · ${formatMoney(resolved.price)}`, 'success');
            updateDisplayedUnitPrice(resolved.price, resolved.comparePrice);
          }
          updateState();
          return eye.variant;
        } catch (error) {
          if (eye.token !== currentToken) return null;
          eye.variant = null;
          setEyeStatus(eye, root.dataset.errorLabel, 'error');
          updateState();
          return null;
        }
      };

      const inferPlanoVariant = async () => {
        if (root.dataset.planoVariantId) {
          return {
            id: root.dataset.planoVariantId,
            available: root.dataset.planoAvailable === 'true',
            price: Number(root.dataset.planoPrice || root.dataset.defaultPrice || 0),
            comparePrice: Number(root.dataset.planoComparePrice || root.dataset.defaultComparePrice || 0)
          };
        }

        const eye = eyes[0];
        if (!eye || eye.selects.length === 0) return defaultVariant;
        const previous = eye.selects.map((select) => select.value);
        let complete = true;
        eye.selects.forEach((select) => {
          const planoOption = Array.from(select.options).find((option) => option.dataset.plano === 'true');
          const actualOptions = Array.from(select.options).filter((option) => option.value);
          if (planoOption) select.value = planoOption.value;
          else if (actualOptions.length === 1) select.value = actualOptions[0].value;
          else complete = false;
        });

        if (!complete) {
          eye.selects.forEach((select, index) => { select.value = previous[index]; });
          return null;
        }

        const resolved = await resolveVariant(eye);
        eye.selects.forEach((select, index) => { select.value = previous[index]; });
        eye.variant = null;
        setEyeStatus(eye, root.dataset.selectLabel, '');
        return resolved;
      };

      let planoVariantPromise = null;
      const getPlanoVariant = () => {
        if (!planoVariantPromise) planoVariantPromise = inferPlanoVariant();
        return planoVariantPromise;
      };

      const calculate = () => {
        if (mode === 'no_power') {
          const quantity = Number(planoQuantity ? planoQuantity.value : 1);
          const cachedPlano = root.dataset.planoVariantId ? {
            id: root.dataset.planoVariantId,
            available: root.dataset.planoAvailable === 'true',
            price: Number(root.dataset.planoPrice || root.dataset.defaultPrice || 0),
            comparePrice: Number(root.dataset.planoComparePrice || root.dataset.defaultComparePrice || 0)
          } : null;
          return {
            valid: Boolean(cachedPlano && cachedPlano.id && cachedPlano.available && quantity > 0),
            total: cachedPlano ? cachedPlano.price * quantity : 0
          };
        }

        const activeEyes = sameToggle && sameToggle.checked ? eyes.slice(0, 1) : eyes;
        const quantitiesValid = activeEyes.some((eye) => Number(eye.quantity.value) > 0);
        const variantsValid = activeEyes
          .filter((eye) => Number(eye.quantity.value) > 0)
          .every((eye) => eye.variant && eye.variant.available);
        const total = activeEyes.reduce((sum, eye) => {
          const quantity = Number(eye.quantity.value);
          return sum + (eye.variant && eye.variant.available ? eye.variant.price * quantity : 0);
        }, 0);
        return { valid: quantitiesValid && variantsValid, total };
      };

      function updateState() {
        if (submitting) return;
        const result = calculate();
        submit.disabled = !result.valid;
        submitLabel.textContent = root.dataset.addLabel;
        totalPrice.textContent = result.valid ? formatMoney(result.total) : '';
        root.dispatchEvent(new CustomEvent('contact-lens:price-change', {
          detail: { price: result.valid && result.total > 0 ? result.total : Number(root.dataset.defaultPrice || 0) }
        }));
      }

      const applyMode = (nextMode) => {
        mode = nextMode;
        modeButtons.forEach((button) => button.setAttribute('aria-selected', String(button.dataset.clMode === mode)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.clPanel !== mode; });
        postAdd.hidden = true;
        setFormMessage('', '');

        if (mode === 'no_power') {
          submit.disabled = true;
          totalPrice.textContent = '';
          getPlanoVariant().then((variant) => {
            if (!variant || !variant.id) {
              setFormMessage(root.dataset.configLabel, 'error');
              return;
            }
            if (!root.dataset.planoVariantId) {
              root.dataset.planoVariantId = variant.id;
              root.dataset.planoAvailable = String(variant.available);
              root.dataset.planoPrice = String(variant.price);
              root.dataset.planoComparePrice = String(variant.comparePrice || root.dataset.defaultComparePrice || 0);
            }
            if (!variant.available) setFormMessage(root.dataset.unavailableLabel, 'error');
            updateDisplayedUnitPrice(variant.price, variant.comparePrice);
            updateState();
          });
        } else {
          updateDisplayedUnitPrice(defaultVariant.price, defaultVariant.comparePrice);
          eyes.forEach((eye) => {
            if (eye.selects.length && eye.selects.every((select) => select.value)) resolveVariant(eye);
            else if (eye.selects.length) eye.variant = null;
          });
          updateState();
        }
      };

      const applySamePrescription = () => {
        if (!sameToggle) return;
        const same = sameToggle.checked;
        const left = eyes.find((eye) => eye.key === 'left');
        const right = eyes.find((eye) => eye.key === 'right');
        eyesContainer.classList.toggle('is-same', same);
        if (left) left.element.querySelector('[data-cl-eye-heading]').textContent = same ? root.dataset.bothLabel : root.dataset.leftLabel;
        if (right) {
          right.element.hidden = same;
          right.selects.forEach((select) => { select.disabled = same; });
          right.quantity.disabled = same;
        }
        syncQuantitySteppers();
        postAdd.hidden = true;
        setFormMessage('', '');
        updateState();
      };

      const lineItemForEye = (eye, eyeLabel, groupId) => {
        const properties = {
          Eye: eyeLabel,
          Prescription: prescriptionSummary(eye) || root.dataset.prescriptionLabel,
          _contact_lens_group: groupId
        };
        eye.selects.forEach((select) => {
          const option = select.options[select.selectedIndex];
          if (option && option.value) properties[select.dataset.optionName] = option.dataset.label || option.textContent.trim();
        });
        return {
          id: Number(eye.variant.id),
          quantity: Number(eye.quantity.value),
          properties
        };
      };

      const buildItems = async () => {
        const groupId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        if (mode === 'no_power') {
          const variant = await getPlanoVariant();
          if (!variant || !variant.id || !variant.available) return [];
          return [{
            id: Number(variant.id),
            quantity: Number(planoQuantity ? planoQuantity.value : 1),
            properties: {
              Prescription: root.dataset.noPowerLabel,
              _contact_lens_group: groupId
            }
          }];
        }

        if (sameToggle && sameToggle.checked) {
          const eye = eyes[0];
          return eye.variant && Number(eye.quantity.value) > 0
            ? [lineItemForEye(eye, root.dataset.bothLabel, groupId)]
            : [];
        }

        return eyes
          .filter((eye) => eye.variant && Number(eye.quantity.value) > 0)
          .map((eye) => lineItemForEye(eye, eye.key === 'left' ? root.dataset.leftLabel : root.dataset.rightLabel, groupId));
      };

      modeButtons.forEach((button) => button.addEventListener('click', () => applyMode(button.dataset.clMode)));
      if (sameToggle) sameToggle.addEventListener('change', applySamePrescription);
      if (planoQuantity) planoQuantity.addEventListener('change', updateState);

      eyes.forEach((eye) => {
        eye.selects.forEach((select) => select.addEventListener('change', () => {
          postAdd.hidden = true;
          setFormMessage('', '');
          if (usesPrescriptionMatrix) {
            const changedIndex = eye.selects.indexOf(select);
            eye.selects.slice(changedIndex + 1).forEach((nextSelect) => { nextSelect.value = ''; });
          }
          resolveVariant(eye);
        }));
        eye.quantity.addEventListener('change', () => {
          postAdd.hidden = true;
          setFormMessage('', '');
          updateState();
        });
        if (eye.selects.length && eye.selects.every((select) => select.value)) resolveVariant(eye);
      });

      root.querySelectorAll('[data-cl-thumbnail]').forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const image = root.querySelector('[data-cl-main-image]');
          if (!image) return;
          root.querySelectorAll('[data-cl-thumbnail]').forEach((item) => {
            const active = item === thumbnail;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          image.classList.add('is-changing');
          image.src = thumbnail.dataset.imageSrc;
          image.srcset = thumbnail.dataset.imageSrcset;
          image.alt = thumbnail.dataset.imageAlt;
          requestAnimationFrame(() => image.classList.remove('is-changing'));
        });
      });

      root.querySelectorAll('[data-cl-product-link]').forEach((select) => {
        select.addEventListener('change', () => {
          if (select.value) window.location.assign(select.value);
        });
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (submit.disabled || submitting) return;
        submitting = true;
        submit.disabled = true;
        submitLabel.textContent = root.dataset.addingLabel;
        postAdd.hidden = true;
        setFormMessage('', '');

        try {
          const items = await buildItems();
          if (!items.length) throw new Error('No valid items');
          const cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(`${cartRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);

          try {
            const cartResponse = await fetch(`${cartRoot}cart.js`, { headers: { 'Accept': 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('.header-cart__count, [data-cart-count]').forEach((counter) => {
                counter.textContent = cart.item_count;
              });
            }
          } catch {
            // The items are already added; a stale header count should not turn a successful add into an error.
          }

          setFormMessage(root.dataset.addedLabel, 'success');
          submitLabel.textContent = root.dataset.addedLabel;
          postAdd.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'contact-lens-product' } }));
        } catch (error) {
          setFormMessage(error.message || root.dataset.errorLabel, 'error');
          submitLabel.textContent = root.dataset.addLabel;
        } finally {
          submitting = false;
          updateState();
        }
      });

      applySamePrescription();
      applyMode(mode);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-contact-lens-product]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eye-test-booking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const distanceBetween = (lat1, lon1, lat2, lon2) => {
      const toRadians = (value) => value * Math.PI / 180;
      const earthRadius = 6371;
      const latDistance = toRadians(lat2 - lat1);
      const lonDistance = toRadians(lon2 - lon1);
      const calculation = Math.sin(latDistance / 2) ** 2
        + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(lonDistance / 2) ** 2;
      return earthRadius * 2 * Math.atan2(Math.sqrt(calculation), Math.sqrt(1 - calculation));
    };

    const initialise = (section) => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';
      const tabs = Array.from(section.querySelectorAll('[data-aa-booking-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-aa-booking-panel]'));
      const cards = Array.from(section.querySelectorAll('[data-aa-booking-store]'));
      const map = section.querySelector('[data-aa-booking-map]');
      const storeName = section.querySelector('[data-aa-booking-store-name]');
      const storeAddress = section.querySelector('[data-aa-booking-store-address]');
      const storeEmail = section.querySelector('[data-aa-booking-store-email]');
      const appointmentType = section.querySelector('[data-aa-booking-type]');
      const search = section.querySelector('[data-aa-booking-search]');
      const locate = section.querySelector('[data-aa-booking-location]');
      const status = section.querySelector('[data-aa-booking-status]');
      const stores = section.querySelector('[data-aa-booking-stores]');
      const empty = section.querySelector('[data-aa-booking-empty]');
      const date = section.querySelector('[data-aa-booking-date]');
      const timeSelect = section.querySelector('[data-aa-booking-time]');
      let activeTest = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.aaBookingTab || 'free';

      if (date) {
        const today = new Date();
        const offset = today.getTimezoneOffset();
        date.min = new Date(today.getTime() - offset * 60000).toISOString().split('T')[0];
      }

      const updateTimeOptions = (card) => {
        if (!timeSelect) return;

        const paidUnavailable = activeTest === 'paid' && card?.dataset.storePaidAvailable === 'false';
        const rawTimes = activeTest === 'paid'
          ? card?.dataset.storePaidTimes || section.dataset.defaultPaidTimes
          : card?.dataset.storeFreeTimes || section.dataset.defaultFreeTimes;
        const slots = (rawTimes || '').split('|').map((slot) => slot.trim()).filter(Boolean);
        const previousValue = timeSelect.value;
        const placeholder = document.createElement('option');

        placeholder.value = '';
        placeholder.textContent = paidUnavailable
          ? section.dataset.rtaUnavailable
          : timeSelect.dataset.placeholder;
        timeSelect.replaceChildren(placeholder);

        if (!paidUnavailable) {
          slots.forEach((slot) => {
            const option = document.createElement('option');
            option.value = slot;
            option.textContent = slot;
            option.selected = slot === previousValue;
            timeSelect.append(option);
          });
        }

        timeSelect.disabled = paidUnavailable || slots.length === 0;
      };

      const chooseStore = (card) => {
        cards.forEach((candidate) => {
          const selected = candidate === card;
          candidate.classList.toggle('is-selected', selected);
          const radio = candidate.querySelector('[data-aa-booking-radio]');
          if (radio) radio.checked = selected;
        });
        if (map && card.dataset.storeQuery) {
          map.src = `https://www.google.com/maps?q=${encodeURIComponent(card.dataset.storeQuery)}&output=embed`;
        }
        if (storeName) storeName.value = card.dataset.storeName || '';
        if (storeAddress) storeAddress.value = card.dataset.storeAddress || '';
        if (storeEmail) storeEmail.value = card.dataset.storeEmail || '';
        updateTimeOptions(card);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((candidate) => candidate.setAttribute('aria-selected', candidate === tab ? 'true' : 'false'));
          panels.forEach((panel) => { panel.hidden = panel.dataset.aaBookingPanel !== tab.dataset.aaBookingTab; });
          activeTest = tab.dataset.aaBookingTab;
          if (appointmentType) appointmentType.value = tab.textContent.trim();
          updateTimeOptions(cards.find((card) => card.classList.contains('is-selected')) || cards[0]);
        });
      });

      cards.forEach((card) => {
        card.querySelector('[data-aa-booking-radio]')?.addEventListener('change', () => chooseStore(card));
      });

      const requestedStore = new URLSearchParams(window.location.search).get('store');
      if (requestedStore) {
        const requestedCard = cards.find((card) => card.dataset.storeSlug === requestedStore);
        if (requestedCard) chooseStore(requestedCard);
      } else if (cards[0]) {
        chooseStore(cards[0]);
      }

      search?.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const haystack = `${card.dataset.storeName} ${card.dataset.storeAddress}`.toLowerCase();
          const match = haystack.includes(query);
          card.hidden = !match;
          if (match) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });

      locate?.addEventListener('click', () => {
        if (!navigator.geolocation) {
          if (status) status.textContent = section.dataset.locationError;
          return;
        }
        locate.disabled = true;
        navigator.geolocation.getCurrentPosition((position) => {
          const sortable = [];
          cards.forEach((card) => {
            const latitude = Number.parseFloat(card.dataset.storeLat);
            const longitude = Number.parseFloat(card.dataset.storeLng);
            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
            const distance = distanceBetween(position.coords.latitude, position.coords.longitude, latitude, longitude);
            sortable.push({ card, distance });
            const label = card.querySelector('[data-aa-booking-distance]');
            if (label) {
              label.textContent = `${distance.toFixed(distance < 10 ? 1 : 0)} km`;
              label.hidden = false;
            }
          });
          sortable.sort((a, b) => a.distance - b.distance).forEach(({ card }) => stores?.append(card));
          if (sortable[0]) chooseStore(sortable[0].card);
          if (status) status.textContent = section.dataset.locationReady;
          locate.disabled = false;
        }, () => {
          if (status) status.textContent = section.dataset.locationError;
          locate.disabled = false;
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      });
    };

    const initialiseAll = () => document.querySelectorAll('[data-aa-eye-booking]').forEach(initialise);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
    else initialiseAll();
    document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const distanceBetween = (lat1, lon1, lat2, lon2) => {
      const toRadians = (value) => value * Math.PI / 180;
      const earthRadius = 6371;
      const latDistance = toRadians(lat2 - lat1);
      const lonDistance = toRadians(lon2 - lon1);
      const calculation = Math.sin(latDistance / 2) ** 2
        + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(lonDistance / 2) ** 2;
      return earthRadius * 2 * Math.atan2(Math.sqrt(calculation), Math.sqrt(1 - calculation));
    };

    const initialise = (section) => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';
      const cards = Array.from(section.querySelectorAll('[data-aa-store-card]'));
      const map = section.querySelector('[data-aa-store-map]');
      const search = section.querySelector('[data-aa-store-search]');
      const locate = section.querySelector('[data-aa-store-location]');
      const status = section.querySelector('[data-aa-store-status]');
      const results = section.querySelector('[data-aa-store-results]');
      const empty = section.querySelector('[data-aa-store-empty]');

      const selectCard = (card) => {
        cards.forEach((candidate) => {
          const selected = candidate === card;
          candidate.classList.toggle('is-selected', selected);
          const button = candidate.querySelector('[data-aa-store-select]');
          if (button) button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (map && card.dataset.storeQuery) {
          map.src = `https://www.google.com/maps?q=${encodeURIComponent(card.dataset.storeQuery)}&output=embed`;
        }
      };

      cards.forEach((card) => {
        card.querySelector('[data-aa-store-select]')?.addEventListener('click', () => selectCard(card));
      });

      search?.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const haystack = `${card.dataset.storeName} ${card.dataset.storeAddress}`.toLowerCase();
          const match = haystack.includes(query);
          card.hidden = !match;
          if (match) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });

      locate?.addEventListener('click', () => {
        if (!navigator.geolocation) {
          if (status) status.textContent = section.dataset.locationError;
          return;
        }
        locate.disabled = true;
        navigator.geolocation.getCurrentPosition((position) => {
          const sortable = [];
          cards.forEach((card) => {
            const latitude = Number.parseFloat(card.dataset.storeLat);
            const longitude = Number.parseFloat(card.dataset.storeLng);
            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
            const distance = distanceBetween(position.coords.latitude, position.coords.longitude, latitude, longitude);
            sortable.push({ card, distance });
            const label = card.querySelector('[data-aa-store-distance]');
            if (label) {
              label.textContent = `${distance.toFixed(distance < 10 ? 1 : 0)} km`;
              label.hidden = false;
            }
          });
          sortable.sort((a, b) => a.distance - b.distance).forEach(({ card }) => results?.append(card));
          if (sortable[0]) selectCard(sortable[0].card);
          if (status) status.textContent = section.dataset.locationReady;
          locate.disabled = false;
        }, () => {
          if (status) status.textContent = section.dataset.locationError;
          locate.disabled = false;
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      });
    };

    const initialiseAll = () => document.querySelectorAll('[data-aa-store-locator]').forEach(initialise);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
    else initialiseAll();
    document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
